import { createFileRoute, redirect } from '@tanstack/react-router';

// The customizable dashboard was absorbed into the Home Overview (one
// dashboard). Redirect old links/bookmarks to Home.
export const Route = createFileRoute('/_dashboard/dashboard/my-dashboard')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/home' });
  },
});
